import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import injectSheet from 'react-jss';

const styles = {
  tooltip: { backgroundColor: props => [`${props.colors.primary} !important`], overflowWrap: 'break-word' },
  root: {
    maxWidth: '290px'
  }
};

class CustomTooltip extends Component {
  static propTypes = {
    children: PropTypes.object,
    classes: PropTypes.object.isRequired,
    title: PropTypes.string
  };

  render() {
    const { classes, children, title } = this.props;
    const { root, ...remaining } = classes;

    return (
      <Tooltip title={title} classes={remaining} placement="top">
        {children}
      </Tooltip>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(CustomTooltip));
